import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';
import Typography from 'brandComponents/Typography';

import {IProductBannedMessageProps} from './IProductBannedMessage';
import messages from './messages';

import styles from './ProductBannedMessage.module.scss';

const ProductBannedMessage = ({className}: IProductBannedMessageProps) => {
	const {managerRepository} = useGeneralProvider();
	const intl = useIntl();

	const handleClick = () => {
		managerRepository.getPopupsMgr().openPopup('productBanned');
	};

	return (
		<div className={cn('product-banned-message', styles['product-banned-message'], className)} onClick={handleClick}>
			<Button showAsLink={true} classNames={cn('product-banned-message__btn', styles['product-banned-message__btn'])}>
				<Typography classNames={cn('t-12', 'product-banned-message__text', styles['product-banned-message__text'])} variant="span">
					{intl.formatMessage(messages.bannedMessage)}
				</Typography>
			</Button>
		</div>
	);
};

export default ProductBannedMessage;
